import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { useLanguage } from "../contexts/LanguageContext";

export const TimeOfDaySelector = ({ value, onChange }) => {
    const { t } = useLanguage();
    
    const timeOptions = [
        { value: "morning", label: t('time_of_day.morning').toUpperCase() },
        { value: "afternoon", label: t('time_of_day.afternoon').toUpperCase() },
        { value: "evening", label: t('time_of_day.evening').toUpperCase() },
        { value: "night", label: t('time_of_day.midnight').toUpperCase() }
    ];
    
    return (
        <div className="w-full">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
                {timeOptions.map((option) => {
                    const isSelected = value === option.value;
                    
                    return (
                        <motion.button
                            key={option.value}
                            type="button"
                            onClick={() => onChange(option.value)}
                            className={cn(
                                "relative px-3 py-3 sm:py-4",
                                "border rounded-sm",
                                "font-inter text-[10px] sm:text-xs tracking-[0.15em] uppercase",
                                "transition-all duration-300",
                                isSelected
                                    ? "border-primary bg-primary/10 text-primary"
                                    : "border-primary/40 bg-transparent text-foreground/70 hover:border-primary/70 hover:text-foreground"
                            )}
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            animate={isSelected ? {
                                boxShadow: [
                                    "0 0 10px hsl(43 66% 52% / 0.15), inset 0 0 10px hsl(43 66% 52% / 0.05)",
                                    "0 0 20px hsl(43 66% 52% / 0.25), inset 0 0 15px hsl(43 66% 52% / 0.08)",
                                    "0 0 10px hsl(43 66% 52% / 0.15), inset 0 0 10px hsl(43 66% 52% / 0.05)"
                                ]
                            } : {
                                boxShadow: "none"
                            }}
                            transition={isSelected ? { duration: 2, repeat: Infinity } : { duration: 0.3 }}
                        >
                            {option.label}
                        </motion.button>
                    );
                })}
            </div>
        </div>
    );
};

export default TimeOfDaySelector;
